import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';


const JangHyeWon = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김춘호 ❤ 장혜원, 저희 결혼합니다!";
    const openDesc = "2025.05.10. 토요일 오후 4:10\n보타닉파크웨딩 로비층 카라홀";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/140/thumb.JPG";


    const lng = 126.82672715031698;
    const lat = 37.56716749667853;

    const placeTelNum = "02-2662-8300";

    const forCar = "네비게이션 : '보타닉파크웨딩 주차장' 또는 '마곡동 760'";
    const forBus = "마곡나루역 정류장 하차\n·   좌석버스 9731 \n·   지선버스 6642, 6645, 6648 \n·   마을버스 강서05-1, 강서07";
    const forSubway = " ·  9호선 - 마곡나루역 1, 2번 출구방면 진입통로 연결\n  ·  공항철도 - 9호선 환승역 방향 마곡나루역 1, 2번 출구\n    방면 진입통로 연결";

    {/* const parents = [
        {groom : "김두희 · 이연숙의 장남"},
        {bride : "❁이석원 · 박영란의 차녀"}
    ] */}

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        // spring 메론 연두 그린
        concept: "SPRING",
        titleColor: "#B2C867",
        pointColor: "#B2C867",
        btnBgColor: "#B2C867",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#f8f3ff",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "저희 결혼합니다.";

    const msg1 = "매년 5월 10일이 되면\n저희는 이날의 사진첩을 꺼내보며\n인생에서 가장 행복했던 기억을 떠올릴 것입니다.";
    const msg2 = "그때, 그 사진 속에\n저희와 함께 웃고 있는\n여러분이 있었으면 좋겠습니다."
    const msg3 = "저희 두 사람의 설레는 시작을\n소중한 걸음으로 축복해주시면 감사하겠습니다."


    const groomAccountList = [
        {
            role: "신랑",
            name: "김춘호",
            bank: "우리은행",
            accountNumber : "1002-960-026136",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FIEEqAnM7"
        }
        ,{
            role: "신랑 부",
            name: "김재봉",
            bank: "신한은행",
            accountNumber : "110-331-197959",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "김정애",
            bank: "국민은행",
            accountNumber : "833401-04-099560",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "장혜원",
            bank: "농협은행",
            accountNumber : "302-9447-7367-91",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FEeZnhgiY"
        }
        ,{
            role: "신부 부",
            name: "장 현",
            bank: "국민은행",
            accountNumber : "052-05-0028-430",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "이현미",
            bank: "카카오뱅크",
            accountNumber : "3333-28-0548887",
            isKakao : false
        }
    ]


    const account_explain = ""

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김춘호",
            call: "010-5003-7147"
        }
        ,{
            role: "신랑 부",
            name: "김재봉",
            call: "010-2588-5479"
        }
        ,{
            role: "신랑 모",
            name: "김정애",
            call: "010-5182-7208"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "장혜원",
            call: "010-9447-7367"
        }
        ,{
            role: "신부 부",
            name: "장 현",
            call: "010-2124-0173"
        },
        {
            role: "신부 모",
            name: "이현미",
            call: "010-9377-7367"
        }
    ]

    const interviewContent = [
        {
            question : "서로의 첫인상은 어땠나요?",
            groomAnswer: "예쁜 빵모자",
            brideAnswer: "멋진 안경남"
        },
        {
            question : "서로의 매력포인트는 무엇인가요?",
            groomAnswer: "상큼깨발랄",
            brideAnswer: "반전매력왕"
        },
        {
            question : "서로를 한마디로 소개해주세요.",
            groomAnswer: "만능끼쟁이",
            brideAnswer: "웃긴 집돌아"
        },
        {
            question : "결혼식은 앞둔 소감이 어떤가요?",
            groomAnswer: "두근거려요",
            brideAnswer: "너무 떨려요"
        },
        {
            question : "하객들에게 전하고 싶은 말은 무엇인가요?",
            groomAnswer: "행복할게요",
            brideAnswer: "잘살게요❤"
        }
    ]

    const informationList =[
        {
            title : "♥신랑신부가 준비한 포토부스 이벤트♥",
            content : "10시30분-12시 운영합니다! \n많이 참여해주세요\n\n예쁜사진과 축하메시지를 남겨주시고,\n인생사진도 마음껏 가져가세요 :D"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#B2C867"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"auto"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                            {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                            <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forSubway={forSubway} forBus={forBus} forCar={forCar} conceptStyle={conceptStyle}/>
                    {/* <Information titleFontSize={"15px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default JangHyeWon;